import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d29cef8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "公司维护", -1))
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增公司")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("添加子公司")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 拖拽文件或"),
  /*#__PURE__*/_createElementVNode("em", null, "点此上传")
], -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("上传开票资料")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("上传营业执照")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("确定")

import { ElMessage, ElMessageBox, genFileId } from 'element-plus'
import tbMix, {cpyCfig} from '@/global_mixin/tableMixin'
import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { formatNumber } from '@/utils/index'
import router from '@/router/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
    // companys list (tree)
    // 'GET/companies': fetchList,
    'GET/companies/tree': fetchList,
    // user list
    'GET/users/list': userListApi,
    // Modification of company name
    'PATCH/companies': companiesPatchApi,
    // Delete company
    'DELETE/companies/{id}': delCompanyApi,
    // create company
    'POST/companies': createCompanyApi,
    // 获取所有公司(无分页)
    'GET/company': companyApi,
    // 获取英文名列表
    'GET/companies/en/page': companiesEnApi,
    // 新增（修改）公司英文名
    'POST/companies/en/create':companiesEncreateApi,
    // 开票公司列表
    'GET/order/invoice_companies': invoice_companiesApi,
} = Api


let { MI_height, MI_tableData, fetchData, page, size, MI_params,
    MI_total, MI_pageChange, MI_identify, MI_modifyForm
} = new tbMix(fetchList)

let All = ref<boolean>(false)
let userOptions = ref([])
let companyOptions: any = ref([])
let companyInvice: any = ref([])

onBeforeMount(() => {
    fetchData({ All })
    userListApi().then((rep: any) => {
        userOptions.value = rep.map((_user: any) => {
            _user.name = _user.alias + '(' + _user.realName + ')'
            return _user
        })
    })

    companyApi().then((rep) => {
        companyOptions.value = rep
    })

    invoice_companiesApi().then((rep: any) => {
        companyInvice.value = rep.map((com: string) => {
        return { label: com, id: com }
        })
    })
})


// 添加公司或子公司
const addCompanyEle = ref()
const isShowAddition: Ref<boolean> = ref(false)
const upLogoEle = ref()
const addForm = reactive({
    pid: 0,
    parentName: '',
    name: '',
    alias: '',
    sort: 0,
    domestic: '',
    status: '',
    minStandard: undefined,
    accountBookCode: '',
    companyCode: '',
    enName: '',
    registeredAddress: '',
    registeredAddressAlias: '',
    logo: [],
    invoiceFile: [],
    licenseFile: [],
    telephone: '',
    bankName: '',
    bankAccount: '',
})
const showAddCompany = (params: {id: number, name: string}) => {
    // 母公司Id
    addForm.pid = params.id
    addForm.parentName = params.name
    isShowAddition.value = true
    addForm.invoiceFile = []
    addForm.licenseFile = []
}
const exceedHandle = (files) => {
  upLogoEle.value!.clearFiles()
  const file = files[0]
  file.uid = genFileId()
  upLogoEle.value!.handleStart(file)
}
const upInvoiceEle = ref()
const exceedInvHandle = (files: File[]) => {
  upInvoiceEle.value!.clearFiles()
  const file: any = files[0]
  file.uid = genFileId()
  upInvoiceEle.value!.handleStart(file)
}

const upLicenseoiceEle = ref()
const exceedLicenseHandle = (files: File[]) => {
  upLicenseoiceEle.value!.clearFiles()
  const file: any = files[0]
  file.uid = genFileId()
  upLicenseoiceEle.value!.handleStart(file)
}
const submitAddition = () => {
    addCompanyEle.value.validate().then((valid: boolean) => {
        if(!valid) return Promise.reject();
        const form = new FormData()

        form.append('pid', addForm.pid)
        form.append('name', addForm.name)
        form.append('alias', addForm.alias)
        form.append('sort', addForm.sort)
        form.append('domestic', addForm.domestic)
        form.append('status', addForm.status)
        form.append('minStandard', addForm.minStandard)
        form.append('accountBookCode', addForm.accountBookCode)
        form.append('companyCode', addForm.companyCode)
        form.append('enName', addForm.enName)
        form.append('registeredAddress', addForm.registeredAddress)
        form.append('registeredAddressAlias', addForm.registeredAddressAlias)
        form.append('telephone', addForm.telephone)
        form.append('bankName', addForm.bankName)
        form.append('bankAccount', addForm.bankAccount)
        form.append('logo', addForm.logo[0].raw)
        form.append('invoiceInfoFile', addForm.invoiceFile?.[0]?.raw)
        form.append('businessLicenseFile', addForm.licenseFile?.[0]?.raw)

        return createCompanyApi(form)
    }).then(() => {
        isShowAddition.value = false
        ElMessage.success('添加成功')
        fetchData(MI_params)
    }).catch((err) => {
        console.log(err);
        
    })
}

// 公司修改
const editCompanyHandle = (row: any) => {
    router.push({name: 'companiesDetail', params: {id: row.id}})
}
// 查看公司账户
const showCompanyAccount = (row: any) => {
    router.push({name: 'companiesDetail', params: {id: row.id}, query: {type: 'account'}})
}

// 公司删除
const delCompanyHandle = (row: any) => {
    ElMessageBox.confirm(`请确认是否删除公司：${row.name}?`, '提示：请谨慎操作', { confirmButtonText: '确认删除', type: 'warning'}).then(() => {
        MI_identify.value = true
        return delCompanyApi({ id: row.id })
    }).then(() => {
        ElMessage.success('删除成功')
        MI_identify.value = false
        fetchData(MI_params)
    }).catch(() => {
        MI_identify.value = false
    })
}

// --------------------英文名维护-----------------------
let { MI_tableData: enData, fetchData: fetchEnData, page: enPage, size: enSize, MI_params: enParams,
    MI_total: enTotal, MI_pageChange: enPageChange,MI_sizeChange: enSizeChange, MI_identify: enIdentify
} = new tbMix(companiesEnApi)
fetchEnData()
let enRows: any = ref([])

const createdEnFg = ref<boolean>(false)
const createdConfig = ref([
    cpyCfig({
        rule: [{ required: true, message: '请选择公司', trigger: 'change' }],
    }),
    /* {
        label: '英文名',
        value: '',
        upKey: 'enName',
        rule: [{ required: true, message: '请输入英文名', trigger: 'change' }],
    } */
    {
        type: 'SELECT',
        label: '公司英文名',
        value: '',
        upKey: 'enName',
        options: companyInvice,
        props: {clearable: true, placeholder: '请选择公司英文名',},
        seleProps: {
        label: 'label',
        valueName: 'id',
        },
    },
])
const createdHandle = () => {
    MI_modifyForm({}, createdConfig, createdEnFg, async (params: any) => {
        await companiesEncreateApi(params)
        ElMessage.success('成功')
        createdEnFg.value = false
        fetchEnData()
    })
}

const modifyEnFg = ref<boolean>(false)
const modifyEnConfig = ref([
    cpyCfig({
        rule: [{ required: true, message: '请选择公司', trigger: 'change' }],
    }),
    /* {
        label: '英文名',
        value: '',
        upKey: 'enName',
        rule: [{ required: true, message: '请输入英文名', trigger: 'change' }],
    } */
    {
        type: 'SELECT',
        label: '公司英文名',
        value: '',
        upKey: 'enName',
        options: companyInvice,
        props: {clearable: true, placeholder: '请选择公司英文名',},
        seleProps: {
        label: 'label',
        valueName: 'id',
        },
    },
])
const modifyEnHandle = () => {
    if(enRows.value.length !== 1){
        ElMessage.warning('请选择一条数据')
        return
    }
    MI_modifyForm( enRows.value[0], modifyEnConfig, modifyEnFg, async (params: any) => {
        await companiesEncreateApi({
            ...params, 
            // companyId: enRows.value[0].companyId,
            id: enRows.value[0].id 
        })
        ElMessage.success('修改成功')
        modifyEnFg.value = false
        fetchEnData()
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showAddCompany({ name: '-', id: 0 })))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "info",
        icon: "refresh",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(fetchData)(_unref(MI_params))))
      }),
      _createVNode(_component_el_checkbox, {
        class: "ml-10",
        modelValue: _unref(All),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(All) ? (All).value = $event : All = $event)),
        label: "展示已注销公司",
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_unref(fetchData)(_unref(MI_params)))),
        border: ""
      }, null, 8, ["modelValue"])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "row-key": "id",
      data: _unref(MI_tableData),
      border: "",
      "max-height": _unref(MI_height) + 30 + 'px',
      class: "mt-10",
      "default-expand-all": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "sort",
          label: "排序",
          width: "135",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "accountBookCode",
          label: "账簿编码",
          width: "90",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "companyCode",
          label: "公司编码",
          width: "90",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "公司名称",
          width: "200",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "enName",
          label: "公司英文名称",
          width: "200",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "alias",
          label: "简称",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "registeredAddress",
          label: "注册地址",
          "min-width": "100",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, { label: "银行账号信息" }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_link, {
              type: "primary",
              onClick: ($event: any) => (showCompanyAccount(row))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "minStandard",
          label: "本地最低标准",
          width: "110",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "状态",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "domestic",
          label: "国内外",
          formatter: (row) => row.domestic === true ? '国内': '国外'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "操作",
          "min-width": "140",
          fixed: "right"
        }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (editCompanyHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, 'Write']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                  onClick: ($event: any) => (showAddCompany(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, 'Create']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (delCompanyHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, 'Delete']
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowAddition.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((isShowAddition).value = $event)),
      title: "新增公司",
      width: "800px",
      onClose: _cache[25] || (_cache[25] = ($event: any) => (addCompanyEle.value.resetFields()))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[22] || (_cache[22] = ($event: any) => (isShowAddition.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[23] || (_cache[23] = ($event: any) => (submitAddition())),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(addForm),
          inline: true,
          "label-position": "top",
          ref_key: "addCompanyEle",
          ref: addCompanyEle
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "母公司",
              prop: "parentName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addForm).parentName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(addForm).parentName) = $event)),
                  class: "form-input",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "公司名称",
              prop: "name",
              rules: [{ required: true, message: '请输入公司名称', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addForm).name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(addForm).name) = $event)),
                  class: "form-input",
                  placeholder: "请输入公司名称",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "公司简称",
              prop: "alias"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addForm).alias,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(addForm).alias) = $event)),
                  class: "form-input",
                  placeholder: "请输入公司简称",
                  clearable: "",
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "本地最低标准",
              prop: "minStandard",
              rules: [{ required: true, message: '请输入本地最低标准', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  controls: false,
                  modelValue: _unref(addForm).minStandard,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(addForm).minStandard) = $event)),
                  class: "form-input",
                  placeholder: "请输入最低标准"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "排序",
              prop: "sort"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  controls: false,
                  modelValue: _unref(addForm).sort,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(addForm).sort) = $event)),
                  class: "form-input",
                  placeholder: "请输入排序"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "国内外",
              prop: "domestic"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(addForm).domestic,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(addForm).domestic) = $event)),
                  placeholder: "请选择国内外",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "国内",
                      value: true
                    }),
                    _createVNode(_component_el_option, {
                      label: "国外",
                      value: false
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "状态",
              prop: "status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(addForm).status,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(addForm).status) = $event)),
                  placeholder: "请选择状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "正常",
                      value: "正常"
                    }),
                    _createVNode(_component_el_option, {
                      label: "注销",
                      value: "注销"
                    }),
                    _createVNode(_component_el_option, {
                      label: "体系外",
                      value: "体系外"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "账簿编码",
              prop: "accountBookCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addForm).accountBookCode,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(addForm).accountBookCode) = $event)),
                  class: "form-input",
                  placeholder: "请输入账簿编码",
                  clearable: "",
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "公司编码",
              prop: "companyCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addForm).companyCode,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(addForm).companyCode) = $event)),
                  class: "form-input",
                  placeholder: "请输入公司编码",
                  clearable: "",
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "电话",
              prop: "telephone",
              rules: [{ required: true, message: '请输入电话', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addForm).telephone,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(addForm).telephone) = $event)),
                  class: "form-input",
                  placeholder: "请输入电话",
                  clearable: "",
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "开户银行",
              prop: "bankName",
              rules: [{ required: true, message: '请输入开户银行', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addForm).bankName,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(addForm).bankName) = $event)),
                  class: "form-input",
                  placeholder: "请输入开户银行",
                  clearable: "",
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "银行账号",
              prop: "bankAccount",
              rules: [{ required: true, message: '请输入银行账号', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addForm).bankAccount,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(addForm).bankAccount) = $event)),
                  class: "form-input",
                  placeholder: "请输入银行账号",
                  clearable: "",
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "公司英文名",
              prop: "enName",
              rules: [{ required: true, message: '请输入公司英文名', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addForm).enName,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(addForm).enName) = $event)),
                  class: "form-input",
                  placeholder: "请输入公司英文名",
                  clearable: "",
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "注册地址",
              prop: "registeredAddress"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"473px"},
                  modelValue: _unref(addForm).registeredAddress,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(addForm).registeredAddress) = $event)),
                  maxlength: "500",
                  class: "form-input",
                  placeholder: "请输入注册地址",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "英文地址",
              prop: "registeredAddressAlias"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"473px"},
                  modelValue: _unref(addForm).registeredAddressAlias,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(addForm).registeredAddressAlias) = $event)),
                  maxlength: "500",
                  class: "form-input",
                  placeholder: "请输入英文地址",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "公司logo:",
              prop: "logo",
              rules: [{ required: true, message: '请上传公司logo', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  ref_key: "upLogoEle",
                  ref: upLogoEle,
                  "file-list": _unref(addForm).logo,
                  "onUpdate:file-list": _cache[19] || (_cache[19] = ($event: any) => ((_unref(addForm).logo) = $event)),
                  drag: "",
                  "auto-upload": false,
                  limit: 1,
                  "on-exceed": exceedHandle,
                  style: {"width":"473px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_upload_filled)
                      ]),
                      _: 1
                    }),
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["file-list"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "开票资料:",
              prop: "invoiceFile",
              rules: [{ required: true, message: '请上传开票资料', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  ref_key: "upInvoiceEle",
                  ref: upInvoiceEle,
                  "file-list": _unref(addForm).invoiceFile,
                  "onUpdate:file-list": _cache[20] || (_cache[20] = ($event: any) => ((_unref(addForm).invoiceFile) = $event)),
                  "auto-upload": false,
                  limit: 1,
                  "on-exceed": exceedInvHandle,
                  style: {"width":"300px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, null, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider),
            _createVNode(_component_el_form_item, {
              label: "营业执照:",
              prop: "licenseFile",
              rules: [{ required: true, message: '请上传营业执照', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  ref_key: "upLicenseoiceEle",
                  ref: upLicenseoiceEle,
                  "file-list": _unref(addForm).licenseFile,
                  "onUpdate:file-list": _cache[21] || (_cache[21] = ($event: any) => ((_unref(addForm).licenseFile) = $event)),
                  "auto-upload": false,
                  limit: 1,
                  "on-exceed": exceedLicenseHandle,
                  style: {"width":"300px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, null, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})